import React from 'react'
import classnames from 'classnames'

import Button from '../Button'

import './DetailsActionButton.less'

const COMPONENT_CLASS = 'nmc-button-action'

export default class DetailsButton extends React.Component {
  render () {
    const headerClass = classnames(COMPONENT_CLASS, this.props.className || [])
    return (
      <Button
        {...this.props}
        disabled={this.props.disabled}
        onClick={this.props.onClick}
        className={headerClass}
      >
        {this.props.children}
      </Button>
    )
  }
}

DetailsButton.propTypes = Button.propTypes



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/DetailsActionButton/index.js